(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('PlatformRentalGeneralStatisticsController', PlatformRentalGeneralStatisticsController);
    PlatformRentalGeneralStatisticsController.$inject = ['$scope', 'VirtualFairService', 'PlatformRentalService', 'DTOptionsBuilder', 'virtualFairs', 'isPlatformRental'];

    function PlatformRentalGeneralStatisticsController($scope, VirtualFairService, PlatformRentalService, DTOptionsBuilder, virtualFairs, isPlatformRental) {
        var vm = this;
        vm.flag                    = false;
        vm.gpData                  = [];
        vm.typeSelected            = -1;
        vm.types                   = [{name:'All', id:-1},{name:'Confirmed', id:1},{name:'Pending', id:0}, {name : 'Attended', id : 2}];
        vm.result                  = [];
        vm.virtualFairSelected     = '';
        vm.getByFilter             = getByFilter;
        vm.percentage              = percentage;
        vm.formatAreaXLabel        = formatAreaXLabel;
        vm.formatAreaYLabel        = formatAreaYLabel;
        vm.virtualFairs            = virtualFairs;
        vm.formatPercent           = formatPercent;
        vm.isPlatformRental        = isPlatformRental;

        // reports

        vm.getNumberOfVisitors = getNumberOfVisitors;
        vm.getByAge = getByAge;
        vm.getByCourseOfInterest = getByCourseOfInterest;
        vm.getWhereWhantStudy = getWhereWhantStudy;

        vm.byAgeGraph = false;

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('paging', false)
            .withOption('info', false);

        function active() {
            // 
        }

        async function getByFilter() {
            vm.byAgeGrapth = await vm.getNumberOfVisitors();
            await vm.getByAge();
            await vm.getByCourseOfInterest();
            await vm.getWhereWhantStudy();
        }

        function percentage(total, qtd)
        {
            if(qtd > 0 && total > 0){
                return ((parseInt(qtd) / parseInt(total))*100).toFixed(2);
            }
            return 0;
        }
        function formatAreaXLabel(input) {
            return (input.src.x).toString();
        }

        function formatAreaYLabel(input) {
            return parseInt(input);
        }

        function formatPercent(input) {
            return input + '%';
        }
        
        async function getNumberOfVisitors() {

            vm.numberOfVisitors = false;
            let query = [];
            query['event_type'] = 'past_event';
            query['virtual_fair_id'] = vm.virtualFairSelected;
            query['type'] = 'all';
            query['platform-rental'] = 1;
            
            return await PlatformRentalService.getNumberOfVisitors(query).then(function(response) {
                // vm.flag = true;
                vm.numberOfVisitors = response.data;
            }).catch(function(err) {
                // 
            });
        }

        async function getByAge() {

            vm.byAgeGraph = false;
            vm.byAgeData = false;

            let query = [];
            query['event_type'] = 'past_event';
            query['virtual_fair_id'] = vm.virtualFairSelected;
            query['type'] = 'all';
            query['platform-rental'] = 1;
            
            if (vm.virtualFairSelected != 498) {
                return await PlatformRentalService.getByAge(query).then(function(response) {
                    vm.byAgeGraph = {labels: [], data: [], options: {rotation: 1 * Math.PI,
                        circumference: 1 * Math.PI}};
                    if(response.data.length) {
                        angular.forEach(response.data, function(value) {
                            vm.byAgeGraph.labels.push(value.label);
                            vm.byAgeGraph.data.push(value.percent);
                        });
                    }
                    vm.byAgeData = response.data;
                }).catch(function(err) {
                });
            }
        }

        async function getByCourseOfInterest() {

            vm.top10Courses = false;
            let query = [];
            query['event_type'] = 'past_event';
            query['virtual_fair_id'] = vm.virtualFairSelected;
            query['type'] = 'all';
            query['platform-rental'] = 1;
            return await PlatformRentalService.getByCourseOfInterest(query).then(function(response) {
                var tmp = []
                if(response.data.length) {
                    angular.forEach(response.data, function(value) {
                        tmp.push({y: value.label, a: value.percent})
                    });
                    vm.top10Courses = tmp;
                }
            }).catch(function(err) {
            });
        }

        async function getWhereWhantStudy() {

            vm.byCountry = false;

            let query = [];
            query['event_type'] = 'past_event';
            query['virtual_fair_id'] = vm.virtualFairSelected;
            query['type'] = 'all';
            query['platform-rental'] = 1;
            
            return await PlatformRentalService.getWhereWhantStudy(query).then(function(response) {
                // vm.byCountry = {table: [], map: {}};
                var tmp = {table: [], map: {}};
                if(response.data.length) {
                    angular.forEach(response.data, function(value) {
                        tmp.table.push(value);
                        if(value.iso.length == 2) {
                            tmp.map[value.iso] = (value.percent).toString();
                        }
                    });
                    vm.byCountry = tmp;
                }
            }).catch(function(err) {
                // 
            });
        }

        active();
    }
})();